import { render, staticRenderFns } from "./HistoryCurve.vue?vue&type=template&id=589e01f6&scoped=true&"
import script from "./HistoryCurve.vue?vue&type=script&lang=js&"
export * from "./HistoryCurve.vue?vue&type=script&lang=js&"
import style0 from "./HistoryCurve.vue?vue&type=style&index=0&id=589e01f6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589e01f6",
  null
  
)

export default component.exports